// Featured Trail Mixes carousel: arrow/scroll navigation, dot indicators,
// and per-card background tint sampled from each product's own image
// (real pixel data, not a guessed or hardcoded color).

function freshTintFromImage(imgEl, callback) {
  var probe = new Image();
  probe.crossOrigin = 'anonymous';
  probe.onload = function () {
    try {
      var size = 16;
      var canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      var ctx = canvas.getContext('2d');
      // Sample the central region only, so a mostly-white packshot
      // background doesn't wash out the pouch's real color.
      var sx = probe.naturalWidth * 0.15;
      var sy = probe.naturalHeight * 0.1;
      var sw = probe.naturalWidth * 0.7;
      var sh = probe.naturalHeight * 0.75;
      ctx.drawImage(probe, sx, sy, sw, sh, 0, 0, size, size);
      var data = ctx.getImageData(0, 0, size, size).data;
      var r = 0, g = 0, b = 0, count = 0;
      for (var i = 0; i < data.length; i += 4) {
        var a = data[i + 3];
        if (a < 128) continue;
        var rr = data[i], gg = data[i + 1], bb = data[i + 2];
        if (rr > 235 && gg > 235 && bb > 235) continue; // skip near-white pixels
        r += rr; g += gg; b += bb; count++;
      }
      if (!count) { callback(null); return; }
      callback([Math.round(r / count), Math.round(g / count), Math.round(b / count)]);
    } catch (e) {
      callback(null); // tainted canvas / load error — leave default background
    }
  };
  probe.onerror = function () { callback(null); };
  probe.src = imgEl.currentSrc || imgEl.src;
}

function freshMixWithWhite(rgb, weight) {
  return 'rgb(' + rgb.map(function (c) {
    return Math.round(c + (255 - c) * weight);
  }).join(',') + ')';
}

document.addEventListener('DOMContentLoaded', function () {
  // This section type can appear more than once on a page (e.g. "Featured"
  // and "Featured bundles"), which means its own <script> tag — and this
  // file — loads and runs once per instance. Guard so setup only runs once
  // per carousel root even if the file executes multiple times.
  document.querySelectorAll('[data-fresh-rec-carousel]:not([data-rec-initialized])').forEach(function (root) {
    root.setAttribute('data-rec-initialized', 'true');
    var track = root.querySelector('[data-rec-track]');
    var prev = root.querySelector('[data-rec-prev]');
    var next = root.querySelector('[data-rec-next]');
    var dotsWrap = root.parentElement ? root.parentElement.querySelector('[data-rec-dots]') : null;
    if (!track) return;

    var cards = Array.prototype.filter.call(track.children, function (el) { return !el.hidden; });

    // Scroll directly to a card's own position rather than scrollBy() —
    // scrollBy()'s smooth animation fights with CSS scroll-snap-type:
    // mandatory, which yanks the track back mid-animation.
    function currentIndex() {
      var trackLeft = track.getBoundingClientRect().left;
      var closest = 0, closestDist = Infinity;
      cards.forEach(function (c, i) {
        var dist = Math.abs(c.getBoundingClientRect().left - trackLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    function scrollToCard(idx) {
      idx = Math.max(0, Math.min(cards.length - 1, idx));
      var card = cards[idx];
      if (!card) return;
      var target = track.scrollLeft + (card.getBoundingClientRect().left - track.getBoundingClientRect().left);
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    // Grey out the arrows once there is nothing further to scroll to, so the
    // controls stop advertising movement that can't happen.
    function updateArrows() {
      if (!prev && !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      // The track carries a couple of px of padding and scroll-snap parks the
      // first card at a non-zero offset, so compare with a tolerance rather
      // than against an exact 0.
      var EPS = 8;
      if (prev) prev.disabled = track.scrollLeft <= EPS;
      if (next) next.disabled = track.scrollLeft >= maxScroll - EPS;
    }

    if (prev) prev.addEventListener('click', function () {
      scrollToCard(currentIndex() - 1);
    });
    if (next) next.addEventListener('click', function () {
      scrollToCard(currentIndex() + 1);
    });

    var dots = [];
    if (dotsWrap && cards.length > 1) {
      dots = cards.map(function (_, i) {
        // A real <button>, not a <span>: these read as clickable, so they
        // have to actually be clickable and reachable by keyboard.
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Go to product ' + (i + 1));
        d.addEventListener('click', function () { scrollToCard(i); });
        dotsWrap.appendChild(d);
        return d;
      });
    }

    var syncTimer;
    function syncState() {
      var idx = currentIndex();
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === idx);
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      updateArrows();
    }
    track.addEventListener('scroll', function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncState, 100);
    });
    window.addEventListener('resize', updateArrows);
    syncState();

    track.querySelectorAll('[data-color-card]').forEach(function (card) {
      var img = card.querySelector('[data-color-img]');
      if (!img) return;
      function apply() {
        freshTintFromImage(img, function (rgb) {
          if (rgb) card.style.backgroundColor = freshMixWithWhite(rgb, 0.55);
        });
      }
      if (img.complete && img.naturalWidth) apply();
      else img.addEventListener('load', apply, { once: true });
    });
  });
});
